export default __webpack_public_path__ + "static/media/logo.961f58ca.svg";